import React, { useState, useEffect, useMemo, useCallback } from 'react';
import { useSelector } from 'react-redux';
import { toast } from 'react-toastify';

import * as Yup from 'yup';

import moment from 'moment';

import { isNull, isArray, concat, isEmpty, get } from 'lodash';

import api from '~/services/api';
import { t, parseDateString } from '~/helpers';
import { Report } from '~/components';
import { RadioGroup, Input } from '~/components/Form';
import { GFO, GFU, GFE, GFE_CONSULTA, ADM } from '~/constants/perfil';


import DateTime from './componentes/DateTime';

function Relquantitativoveiculosvalortotal() {
  const [open, setOpen] = useState(true);

  const [cosiimrdiaini, setCosiimrdiaini] = useState(15);
  const [cosiimrdiafim, setCosiimrdiafim] = useState(14);

  const [pickerFatuDataVencimento, setPickerFatuDataVencimento] = useState(null);

  const [pickerDataIni, setPickerDataIni] = useState(null);
  const [pickerDataFim, setPickerDataFim] = useState(null);

  // Pegando o mês (0-11, por isso é necessário adicionar 1 para obter o valor correto)
  //const month = currentDate.month() + 1;  // Adiciona 1 porque o mês começa em 0 (Janeiro = 0)

  // Pegando o ano (ex: 2024)
  //const year = currentDate.year();

  //const formattedDate = `$16/${currentDate.getMonth() + 1}/${currentDate.getFullYear()}`;

  //const specificDate = moment(formattedDate);  // Data no formato YYYY-MM-DD

  //const isAfter = currentDate.isAfter(specificDate);  // Se a data atual for posterior

  //console.log(isAfter);


  const [filtro, setFiltro] = useState([]);

  const [selecionaranomesInicial, setSelecionaranomesInicial] = useState({});
  const [periodoconsultaInicial, setPeriodoconsultaInicial] = useState('');
  const [periodoconsultafimInicial, setPeriodoconsultafimInicial] = useState('');
  const [periodoconsultainiInicial, setPeriodoconsultainiInicial] = useState('');

  const [selecionaranomesFinal, setSelecionaranomesFinal] = useState({});
  const [periodoconsultaFinal, setPeriodoconsultaFinal] = useState('');
  const [periodoconsultafimFinal, setPeriodoconsultafimFinal] = useState('');
  const [periodoconsultainiFinal, setPeriodoconsultainiFinal] = useState('');

  const [datahoranovocontrolefaturamento, setDatahoranovocontrolefaturamento] = useState(null);
  const [datahoranovocontrolefaturamentofim, setDatahoranovocontrolefaturamentofim] = useState(null);

  const {
    glousuariotipo,
    glousuariologin,
    glousuarioorgacodigo,
    glousuarioorganome,
  } = useSelector((state) => state.user.profile);
  const { token } = useSelector((state) => state.auth);


  const startDate = '15/08/2024 00:00:00';
  const endDate = '15/08/2025 00:00:00';
  // const startDate = '2024-08-15T00:00:00';
  // const endDate = '2025-10-15T00:00:00';


  const getMonthsBetweenDates = (startDate, endDate) => {
    const start = new Date(startDate);
    const end = new Date(endDate);
    const months = [];

    if (start > end) {
      return [];
    }

    let current = new Date(start.getFullYear(), start.getMonth(), 1);

    while (current <= end) {
      const month = String(current.getMonth() + 1).padStart(2, '0');
      const year = current.getFullYear();
      months.push(`${month}/${year}`);
      current.setMonth(current.getMonth() + 1);
    }

    return months;
  };

  async function getConfigSistema() {
    try {
      //setIsLoading(true);

      const response = await api.get(`/configsistema`);

      const statusRetorno = get(
        response,
        'data.cosi_imr_dia_fim',
        ''
      );

      const datahoranovocontrolefaturamentolocal = get(
        response,
        'data.cosi_datahora_novo_controle_faturamento',
        ''
      );

      const cosiimrdiainilocal = get(
        response,
        'data.cosi_imr_dia_ini',
        '15'
      );

      const cosiimrdiafimlocal = get(
        response,
        'data.cosi_imr_dia_fim',
        '14'
      );

      //await setIsLoading(false);
      if (String(statusRetorno) === '') {
        toast.error('Não foi possível fazer a consulta!');
        return;
      }
      setCosiimrdiaini(cosiimrdiainilocal);
      setCosiimrdiafim(cosiimrdiafimlocal);
      setDatahoranovocontrolefaturamento(datahoranovocontrolefaturamentolocal);

      // setDatahoranovocontrolefaturamentofim(moment());



      // Formatação personalizada da data
      // const formattedDate = `16/${currentDate.getMonth() + 1}/${currentDate.getFullYear()} 23:59:59`;
      //const formattedDate = `${currentDate.getFullYear()}-${currentDate.getMonth()}-01 00:00:00`;

      const currentDate = new Date();
      const currentDateMoment = moment();
      let formattedDate = `${currentDate.getFullYear()}-${currentDate.getMonth() + 1}-${cosiimrdiafimlocal} 00:00:00`;
      let specificDate = moment(formattedDate);
      // const isAfter = currentDateMoment.isAfter(specificDate);  // Se a data atual for posterior
      const isBefore = currentDateMoment.isBefore(specificDate);  // Se a data atual for anterior
      // const isSame = currentDateMoment.isSame(specificDate, 'day');

      if (isBefore) {
        formattedDate = `${currentDate.getFullYear()}-${currentDate.getMonth()}-01 00:00:00`;
        specificDate = moment(formattedDate);
      }

      setDatahoranovocontrolefaturamentofim(specificDate);
      setPickerFatuDataVencimento(specificDate);
      setPickerDataIni(specificDate);
      setPickerDataFim(specificDate);

      // console.log(formattedDate);
      // console.log(specificDate);
      // console.log("isAfter" + isAfter);
      // console.log("isBefore" + isBefore);
      // console.log("isSame" + isSame);

    } catch (err) {
      setCosiimrdiaini(15);
      setCosiimrdiafim(14);
      toast.error(` ${err} `);
    }
  }


  const onSerializeData = useCallback(
    (data) => {
      console.log(data);

      const formatDate = (inputDate) => {
        const [datePart, timePart] = inputDate.split(' ');
        const [day, month, year] = datePart.split('/');
        return `${year}-${month}-${day}T${timePart}`;
      };

      const formattedDatestartDate = pickerDataIni;
      const formattedDateendDate = pickerDataFim;
      // const formattedDatestartDate = formatDate(periodoconsultafimInicial);
      // const formattedDateendDate = formatDate(periodoconsultafimFinal);
      console.log(periodoconsultafimFinal);


      const months = getMonthsBetweenDates(formattedDatestartDate, formattedDateendDate);


      months.map((month, index) => (
        console.log(index + " > " + month)
      ))



      return {
        ...data,
        cosiimrdiaini: cosiimrdiaini,
        cosiimrdiafim: cosiimrdiafim,
        months: months,
        periodoinicial: periodoconsultaInicial,
        periodoconsultainiinicial: periodoconsultainiInicial,
        periodoconsultafiminicial: periodoconsultafimInicial,
        periodofinal: periodoconsultaFinal,
        periodoconsultainifinal: periodoconsultainiFinal,
        periodoconsultafimfinal: periodoconsultafimFinal
      };
    },
    [filtro, periodoconsultaInicial, periodoconsultainiInicial, periodoconsultafimInicial,
      periodoconsultaFinal, periodoconsultainiFinal, periodoconsultafimFinal,
      pickerDataIni, pickerDataFim
    ]
  );

  const handleValidate = useCallback(
    async (data) => {
      try {

        const schema = Yup.object().shape({
          periodo: Yup.string()
            .nullable()
            .required(t('s.geral.validacao.campoobrigatorio')),
        });

        await schema.validate({
          ...data,
          periodo: periodoconsultaInicial
        }, {
          abortEarly: false,
        });

      } catch (err) {
        const form = {};

        if (err instanceof Yup.ValidationError) {
          err.inner.forEach((error) => {
            form[error.path] = error.message.replace(`${error.path} `, '');
          });

          throw { form };
        }
      }
    },
    [filtro, periodoconsultaInicial]
  );

  const handleChangeDatapickerDataIni = React.useCallback((value) => {
    console.log(value);
    //let data =  moment(value, 'YYYY-MM-DD HH:mm:ss', true).format('DD/MM/YYYY');
    setPickerDataIni(value);

    // let dataAtual = moment().format("YYYY-MM-DD");
    // let dtnDig = moment(value, "YYYY-MM-DD HH:mm:ss").format("YYYY-MM-DD");
    // let dtnFaturaEnvio = moment(data.fatu_data_envio_fatura, "YYYY-MM-DD HH:mm:ss").format("YYYY-MM-DD");
    // let dtnDigFatura = moment(fatuDataFatura, "YYYY-MM-DD HH:mm:ss").format("YYYY-MM-DD");
    // console.log(data);
  }, []);



  const handleChangeDatapickerDataFim = React.useCallback((value) => {
    console.log(value);
    //let data =  moment(value, 'YYYY-MM-DD HH:mm:ss', true).format('DD/MM/YYYY');
    setPickerFatuDataVencimento(value);
    setPickerDataFim(value);

    // let dataAtual = moment().format("YYYY-MM-DD");
    // let dtnDig = moment(value, "YYYY-MM-DD HH:mm:ss").format("YYYY-MM-DD");
    // let dtnFaturaEnvio = moment(data.fatu_data_envio_fatura, "YYYY-MM-DD HH:mm:ss").format("YYYY-MM-DD");
    // let dtnDigFatura = moment(fatuDataFatura, "YYYY-MM-DD HH:mm:ss").format("YYYY-MM-DD");
    // console.log(data);
  }, []);


  useEffect(() => {
    if (!isEmpty(selecionaranomesInicial)) {
      let month = parseInt(selecionaranomesInicial.split('/')[0], 10);
      let year = parseInt(selecionaranomesInicial.split('/')[1], 10);
      if (month === 1) {
        month = 12;
        year = year - 1;
      } else {
        month = month - 1;
      }
      const formattedMonth = month.toString().padStart(2, '0');
      const formattedyear = year.toString().padStart(4, '0');
      // console.log(`${cosiimrdiaini}/${formattedMonth}/${formattedyear} 00:00:00`);
      // console.log(`${cosiimrdiafim}/${selecionaranomesInicial} 23:59:59`);
      setPeriodoconsultainiInicial(`${cosiimrdiaini}/${formattedMonth}/${formattedyear} 00:00:00`);
      setPeriodoconsultafimInicial(`${cosiimrdiafim}/${selecionaranomesInicial} 23:59:59`);
      const periodo = `${cosiimrdiaini}/${formattedMonth}/${formattedyear} - ${cosiimrdiafim}/${selecionaranomesInicial}`;
      setPeriodoconsultaInicial(periodo)
    }
  }, [selecionaranomesInicial, cosiimrdiaini, cosiimrdiafim]);

  useEffect(() => {
    if (!isEmpty(selecionaranomesFinal)) {
      let month = parseInt(selecionaranomesFinal.split('/')[0], 10);
      let year = parseInt(selecionaranomesFinal.split('/')[1], 10);
      if (month === 1) {
        month = 12;
        year = year - 1;
      } else {
        month = month - 1;
      }
      const formattedMonth = month.toString().padStart(2, '0');
      const formattedyear = year.toString().padStart(4, '0');
      // console.log(`${cosiimrdiaini}/${formattedMonth}/${formattedyear} 00:00:00`);
      // console.log(`${cosiimrdiafim}/${selecionaranomesFinal} 23:59:59`);
      setPeriodoconsultainiFinal(`${cosiimrdiaini}/${formattedMonth}/${formattedyear} 00:00:00`);
      setPeriodoconsultafimFinal(`${cosiimrdiafim}/${selecionaranomesFinal} 23:59:59`);
      const periodo = `${cosiimrdiaini}/${formattedMonth}/${formattedyear} - ${cosiimrdiafim}/${selecionaranomesFinal}`;
      setPeriodoconsultaFinal(periodo)
    }
  }, [selecionaranomesFinal, cosiimrdiaini, cosiimrdiafim]);

  useEffect(() => {
    getConfigSistema();
  }, []);

  return (
    <Report
      open={open}
      onClose={() => setOpen(false)}
      title="Relatório Quantitativo veículos e valor total"
      relatorio="relquantitativoveiculosvalortotal"
      // serialize={(param) => onSerializeData(param)}
      serialize={onSerializeData}
      validate={handleValidate}
      initials={{
        tipo: 'pdf',
      }}
    >

      <DateTime
        // time
        label="Selecione o mês e ano inícial"
        name="selecionaranomesinicial"
        disableFuture={true}
        invalidDateMessage={''}
        minDateMessage={''}
        maxDateMessage={''}
        minDate={isNull(datahoranovocontrolefaturamento) ? '' : datahoranovocontrolefaturamento}
        maxDate={isNull(datahoranovocontrolefaturamentofim) ? '' : datahoranovocontrolefaturamentofim}

        value={pickerDataIni}

        onChange={handleChangeDatapickerDataIni}


        getValue={(value) => {
          setSelecionaranomesInicial(value)

        }
        }
        serialize={(value) =>
          value
            .set({ hour: 0, minute: 0, seconds: 0 })
            .format('MM/YYYY')
        }
      />

      {/* const [pickerDataInicio, setPickerDataInicio] = useState(null);
      const [pickerDataFim, setPickerFatuDataFim] = useState(null); */}


      <DateTime
        // time
        label="Selecione o mês e ano final"
        name="selecionaranomesfinal"
        disableFuture={true}
        invalidDateMessage={''}
        minDateMessage={''}
        maxDateMessage={''}
        minDate={isNull(datahoranovocontrolefaturamento) ? '' : datahoranovocontrolefaturamento}
        maxDate={isNull(datahoranovocontrolefaturamentofim) ? '' : datahoranovocontrolefaturamentofim}

        value={pickerDataFim}

        onChange={handleChangeDatapickerDataFim}

        getValue={(value) => {
          setSelecionaranomesFinal(value)
        }
        }
        serialize={(value) =>
          value
            .set({ hour: 0, minute: 0, seconds: 0 })
            .format('MM/YYYY')
        }
      />


      {/* <Input
        name="periodo"
        label="Período"
        value={periodoconsultaInicial}
        disabled
      /> */}

      <RadioGroup
        row
        name="tipo"
        label="Formato"
        options={[
          { label: 'PDF', value: 'pdf' },
          { label: 'Excel', value: 'xls' },
        ]}
      />
    </Report>
  );
}

export default Relquantitativoveiculosvalortotal;
